export const productOfProductsTranslations = {
  FROM: '#from what element the product is displayed#',
  TO: '#to what element the product is displayed#',
  ALL: '#all the products#',
};
export const PRODUCTS_LABEL_TRANSLATION = '#number of products#';
export const MAX_DISPLAYED_NUMBER_OF_RECORDS = 10;
